export const SET_PIN_NEEDED = 'CAST::SET_PIN_NEEDED';
export const SET_ASSET_TO_CAST = 'CAST::SET_ASSET_TO_CAST';
